import { FETCH_LAST_SEARCH } from '../actions/lastSearch';

export default function lastSearch(state = null, { type, payload }) {
    switch (type) {
        case FETCH_LAST_SEARCH:
            return payload;
        default:
            return state;
    }
}
